import { ProductionStatus } from "@enums/productionStatus.enum";

export function GetProductionStatusColorOpsPlannerButtonText(status: ProductionStatus) {
	switch (status) {
		case ProductionStatus.Active:
		case ProductionStatus.Changeover:
			return "#40AA58";
		case ProductionStatus.ToiletBreak:
		case ProductionStatus.Break:
		case ProductionStatus.QLoop:
		case ProductionStatus.QualityCheck:
		case ProductionStatus.AssistanceRequired:
			return "#EA580A";
		case ProductionStatus.Idle:
		case ProductionStatus.Inactive:
		case ProductionStatus.InitialCheckFailed:
		case ProductionStatus.Breakdown:
		case ProductionStatus.Maintenance:
			return "#DF3F40";
		default:
			return "blue";
	}
}